"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeTransaction = encodeTransaction;
const gtx_1 = require("../gtx/gtx");
/**
 *
 * Encodes the gtx using ASN.1.
 * @returns the gtx encoded
 */
function encodeTransaction(gtx) {
    return (0, gtx_1.serialize)(gtx);
}
//# sourceMappingURL=encodeTransaction.js.map